firebird.factory('videoLayoutSpotlightService', [
    '$window',
    'logService',
    'contentService',
    'analyticsWrapperService',
    'annotationService',
    'videoroomService',
    'videoGlobalService',
    function (
        $window,
        logService,
        contentService,
        analyticsWrapperService,
        annotationService,
        videoroomService,
        videoGlobalService
    ) {
        var service = {
            initialize: initialize
        };

        var self;

        return service;

        function initialize(selfParam) {
            self = selfParam;

            if (videoGlobalService.test) {
                $window = videoGlobalService.data.$window;
            }

            self.toggleVideoCheck = toggleVideoCheck;
            self.toggleVideoFullsize = toggleVideoFullsize;

            self.setSpotlightVideo = setSpotlightVideo;
        }

        // before toggle check for certain conditions, do analytics, and call toggleVideoFullsize
        function toggleVideoCheck(target) {
            if (self.layoutPage && !self.isLayoutPageVideoExpandable(target)) {
                // small video is not expandable
                return;
            }

            if ($window.$(target).hasClass('annotation')) {
                return;
            }

            // clear up slowlink events history first
            $window.$('#videoroom-videos > div').each(function (index, item) {
                if (item.slowLinkCount && item.remoteFeed) {
                    delete item.slowLinkCount;
                }
            });

            if (target === self.maxvideo) {
                self.preferredLayout = 'grid';
                analyticsWrapperService.eventTrack('Meeting - Enabled Group Layout', { sfuEvent: true });
            } else {
                self.preferredLayout = 'spotlight';
                analyticsWrapperService.eventTrack('Meeting - Enabled Spotlight Layout', { sfuEvent: true });
            }

            self.toggleVideoFullsize(target);

            if (contentService.isContentPlaying() && contentService.getContentType() === 'screenshare') {
                annotationService.clearCanvas();
            }
        }

        // To toggle the full size property of a video element, update the max video property,
        // and re-do the videos layout. Also update the simulcast for remote video feeds.
        // Note that at most one video element may be in full size at any time. If the video
        // element is not full size, it is marked as full size and any previous full size is
        // unmarked. If the video element is already full size, then it is marked as not
        // full size, so that no video element is full size in the layout.
        function toggleVideoFullsize(videodiv) {
            if (self.layoutPage) {
                // refactor toggleVideoFullsize and setSpotlightVideo to one.
                self.onLayoutPageToggleSpotlight(videodiv);
                self.updateVideosLayout();
                return;
            }

            var oldmax = self.maxvideo;
            if (self.maxvideo == videodiv) {
                self.setSpotlightVideo(null);
            } else {
                self.setSpotlightVideo(videodiv);
            }
            if (oldmax && !self.maxvideo) {
                // set all videos with normal quality
                self.simulcastReason = 'toggleVideoFullsize spotlight to non-spotlight';
                $window.$('#videoroom-videos > div:not(.audioonly)').each(function (index, div) {
                    self.setSimulcast(div);
                });
            } else {
                if (oldmax) {
                    self.simulcastReason = 'toggleVideoFullsize old was spotlight';
                    // set old video with low quality
                    self.setSimulcast(oldmax);
                } else {
                    self.simulcastReason = 'toggleVideoFullsize old was not spotlight';
                    // set all other videos to low quality
                    $window.$('#videoroom-videos > div:not(.audioonly)').each(function (index, div) {
                        if (div != self.maxvideo) {
                            self.setSimulcast(div);
                        }
                    });
                }
                if (self.maxvideo) {
                    self.simulcastReason = 'toggleVideoFullsize new is spotlight';
                    // set new video with high quality.
                    self.setSimulcast(self.maxvideo);
                }
            }

            self.updateVideosLayout();
        }

        // set the maxvideo variable, and hasSpotlight attribute.
        function setSpotlightVideo(div) {
            if (self.layoutPage) {
                if (div && div == self.maxvideo) {
                    logService.log('videoroomCtrl - already spotlight in setSpotlightVideo, ignored');
                } else {
                    self.onLayoutPageToggleSpotlight(div);
                }
                return;
            }

            var old = self.maxvideo;
            self.maxvideo = div;

            //Set layout var in videoroomService to allow other ctrls to check which layout is being used
            if (!div) {
                self.setCurrentLayout(videoroomService.layouts.GALLERY);
            } else {
                self.setCurrentLayout(videoroomService.layouts.SPOTLIGHT);
            }

            if (!div) {
                $window.$('#videoroom-videos').removeAttr('hasSpotlight');
            } else {
                $window.$('#videoroom-videos').attr('hasSpotlight', 'true');
            }
            if (old) {
                old.removeAttribute('spotlight');
            }
            if (div) {
                div.setAttribute('spotlight', 'true');
            }
        }
    }
]);
